import { Controller } from '@hotwired/stimulus';

const ENTRANCE_HIDDEN_CLASS = 'teaser-element--entrance';
const ENTRANCE_VISIBLE_CLASS = 'teaser-element--entrance-in';

export default class extends Controller {
    static targets = ['card', 'loadMore'];

    static values = {
        entranceEnabled: Boolean,
    };

    connect() {
        this.visibleCount = 6;
        this.cardObservers = new Map();
        this.showCards();
        this.setupEntranceAnimation();
    }

    disconnect() {
        this.cardObservers.forEach((observer) => observer.disconnect());
        this.cardObservers.clear();
    }

    showCards() {
        this.cardTargets.forEach((card, index) => {
            card.style.display = index < this.visibleCount ? 'flex' : 'none';
        });

        if (this.visibleCount >= this.cardTargets.length) {
            this.loadMoreTarget.style.display = 'none';
        } else {
            this.loadMoreTarget.style.display = 'block';
        }
    }

    loadMore() {
        this.visibleCount += 6;
        this.showCards();
        this.setupEntranceAnimation();
    }

    setupEntranceAnimation() {
        if (!this.entranceEnabledValue || this.prefersReducedMotion()) {
            return;
        }

        const visibleCards = this.cardTargets.filter((card) => card.style.display !== 'none');

        if (!('IntersectionObserver' in window)) {
            visibleCards.forEach((card) => card.classList.remove(ENTRANCE_HIDDEN_CLASS));
            return;
        }

        visibleCards.forEach((card) => {
            if (this.cardObservers.has(card)) {
                return;
            }

            const observer = new IntersectionObserver(
                (entries) => this.onCardIntersect(entries, card, observer),
                { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
            );
            observer.observe(card);
            this.cardObservers.set(card, observer);
        });
    }

    onCardIntersect(entries, card, observer) {
        for (const entry of entries) {
            if (!entry.isIntersecting) {
                continue;
            }

            card.classList.add(ENTRANCE_VISIBLE_CLASS);
            observer.disconnect();
            this.cardObservers.delete(card);
            return;
        }
    }

    prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
}
